import { toast } from "sonner";

import { CopyNotification } from "@/components/buttons/share-button";
import CopyIcon from "@/components/icons/copy-icon";
import { Button } from "@/components/ui/button";

interface CopyCodeProps {
  children: string;
}

export default function CopyCode({ children }: CopyCodeProps) {
  const handleCopy = () => {
    navigator.clipboard.writeText(children);
    toast.custom((id) => (
      <CopyNotification
        label={`Copied ${children} to clipboard!`}
        onClose={() => toast.dismiss(id)}
      />
    ));
  };

  return (
    <div className="relative mx-auto mt-[3px] flex h-10 items-center justify-center overflow-hidden rounded-[5px] shadow-0-4-4 shadow-black/10 md:h-7">
      <p className="bg-black/40 px-4 py-2 font-semibold text-18 md:px-2.5 md:py-[7px] md:text-12">
        {children}
      </p>
      <Button
        className="h-full shrink-0 rounded-none bg-black/50 p-2 transition-colors hover:bg-black/30"
        onClick={handleCopy}
      >
        <CopyIcon className="size-5 md:size-4" />
      </Button>
    </div>
  );
}
